module.exports = __webpack_public_path__ + "static/media/home.bf3c2e51.svg";